'use strict';
(function() {
  theme.PriceRange = function() {
    function h(b, {onChange:a, onUpdate:d} = {}) {
      this.container = b;
      this.onChange = a;
      this.onUpdate = d;
      return this.init();
    }
    function e(b, a) {
      let d;
      return c => {
        a = 8 === c.keyCode || 46 === c.keyCode ? 2000 : 1000;
        clearTimeout(d);
        d = setTimeout(function(f) {
          b.apply(this, c);
        }, a);
      };
    }
    h.prototype = Object.assign({}, h.prototype, {init:function() {
      if (!this.container.classList.contains("price-range")) {
        throw Error("Invalid container");
      }
      this.formEl = this.container.closest("form");
      this.inputMinEl = this.container.querySelector(".price-range__input-min");
      this.inputMaxEl = this.container.querySelector(".price-range__input-max");
      this.inputMinEl.addEventListener("keyup", e(b => {
        this.onChange && (b = new FormData(this.formEl), this.onChange(b), document.dispatchEvent(new Event("filter:selected")));
      }, 1000));
      this.inputMaxEl.addEventListener("keyup", e(() => {
        if (this.onChange) {
          const b = new FormData(this.formEl);
          this.onChange(b);
          document.dispatchEvent(new Event("filter:selected"));
        }
      }, 1000));
    }, onFormSubmit:function() {
    }});
    return h;
  }();
  theme.reinitProductGridItem = function(h) {
    window.SPR && (SPR.initDomEls(), SPR.loadBadges());
    theme.collapsibles.init();
  };
  theme.Filter = function() {
    function h({sections:e, onReplace:b} = {}) {
      this.sections = e || [];
      this.cachedSections = [];
      this.onReplace = b;
    }
    h.prototype = Object.assign({}, h.prototype, {renderPage:function(e, b, a = !0) {
      const d = new URLSearchParams(window.location.search), c = this.getUpdatedParams(d, b);
      b = this.sections.map(f => {
        const g = `${e}?section_id=${f.sectionId}&${c.toString()}`, k = m => m.url === g;
        return this.cachedSections.some(k) ? this.renderSectionFromCache(k, f) : this.renderSectionFromFetch(g, f);
      });
      a && this.updateURLHash(c);
      return Promise.all(b);
    }, renderSectionFromCache:function(e, b) {
      e = this.cachedSections.find(e);
      this.renderSection(e.html, b);
      return Promise.resolve(b);
    }, renderSectionFromFetch:function(e, b) {
      return new Promise((a, d) => {
        fetch(e).then(c => c.text()).then(c => {
          this.cachedSections = [...this.cachedSections, {html:c, url:e}];
          this.renderSection(c, b);
          a(b);
        }).catch(c => d(c));
      });
    }, renderSection:function(e, b) {
      const a = (new DOMParser()).parseFromString(e, "text/html");
      if (this.onReplace) {
        this.onReplace(a, b);
      } else {
        if ("string" === typeof b.nodeId) {
          e = a.getElementById(b.nodeId);
          if (!e) {
            return;
          }
          document.getElementById(b.nodeId).innerHTML = e.innerHTML;
        } else {
          b.nodeId.forEach(d => {
            document.getElementById(d).innerHTML = a.getElementById(d).innerHTML;
          });
        }
      }
      return b;
    }, getUpdatedParams:function(e, b) {
      e = new URLSearchParams(e);
      const a = ["sort_by", "q", "options[prefix]", "type"];
      for (const [d, c] of e.entries()) {
        b.getAll(d).includes(c) || a.includes(d) || e.delete(d);
      }
      for (const [d, c] of b.entries()) {
        e.getAll(d).includes(c) || "" === c || e.append(d, c);
      }
      return e;
    }, updateURLHash:function(e) {
      history.pushState({}, "", `${window.location.pathname}${e && "?".concat(e)}`);
    }});
    return h;
  }();
  theme.CollectionSidebar = function() {
    function h() {
      document.getElementById(e.sidebarId) && (document.addEventListener("filter:selected", this.close.bind(this)), this.init());
    }
    var e = {sidebarId:"CollectionSidebar", trigger:".filters-toolbar__btn", mobileWrapper:"#CollectionInlineFilterWrap", filters:".filter-wrapper", filterBar:".filters-toolbar"}, b = !1;
    h.prototype = Object.assign({}, h.prototype, {init:function() {
      b = !1;
      slate.a11y.unlockMobileScrolling(".filters-toolbars");
      this.container = document.getElementById(e.sidebarId);
      this.trigger = document.querySelector(e.trigger);
      this.wrapper = document.querySelector(e.mobileWrapper);
      this.filters = this.wrapper.querySelector(e.filters);
      null != this.trigger && (this.trigger.off("click"), this.trigger.on("click", this.toggle.bind(this)));
    }, toggle:function() {
      b ? this.close() : this.open();
    }, open:function() {
      var a = this.resize();
      window.scrollTo({top:a, behavior:"smooth"});
      this.trigger.classList.add("is-active");
      document.querySelector(e.filterBar).style.zIndex = 28;
      document.documentElement.classList.add("js-drawer-open");
      theme.Helpers.prepareTransition(this.filters, function() {
        this.filters.classList.add("is-active");
      }.bind(this));
      b = !0;
      this.bindEvents();
    }, close:function(a) {
      a && "touchend" == a.type && a.target.closest(".collection-mobile-filters") || (null != this.trigger && this.trigger.classList.remove("is-active"), theme.Helpers.prepareTransition(this.filters, function() {
        this.filters.classList.remove("is-active");
      }.bind(this)), b = !1, document.querySelector(e.filterBar).style.zIndex = 27, setTimeout(function() {
        document.documentElement.classList.remove("js-drawer-open");
      }, 50), this.unbindEvents());
    }, resize:function() {
      var a = document.querySelector("#SiteHeader"), d = document.querySelector("#AnnouncementWrapper"), c = document.querySelector(".filters-toolbar"), f = c.offsetHeight;
      c = c.getBoundingClientRect().top;
      var g = window.pageYOffset || document.documentElement.scrollTop, k = 0, m = 0;
      document.querySelector(".site-header-blurred") && (m = 30);
      null != d && "true" == d.dataset.sticky && (k += d.offsetHeight);
      null != a && "sticky" == a.dataset.sticky && (k += a.offsetHeight);
      document.documentElement.style.setProperty("--filtersHeight", window.innerHeight - k - f + "px");
      return c + g - k - m;
    }, onSelect:function() {
      this.open();
    }, bindEvents:function() {
      window.on("touchend.filters-toolbars", function(a) {
        a.target.closest(".filters-toolbar__btn") || this.close(a);
      }.bind(this));
      window.on("keyup.filters-toolbars", function(a) {
        27 === a.keyCode && this.close();
      }.bind(this));
      slate.a11y.lockMobileScrolling(".filters-toolbars");
    }, unbindEvents:function() {
      window.off("touchend.filters-toolbars");
      window.off("keyup.filters-toolbars");
      slate.a11y.unlockMobileScrolling(".filters-toolbars");
    }});
    return h;
  }();
  theme.Collection = function() {
    function h(a) {
      this.container = a;
      this.containerId = a.id;
      this.sectionId = a.getAttribute("data-section-id");
      this.namespace = ".collection-" + this.sectionId;
      this.isCollectionTemplate = this.container.dataset.collectionTemplate;
      this.ajaxRenderer = new theme.Filter({sections:[{sectionId:this.sectionId, nodeId:"CollectionFilteredContent"}], onReplace:this.onReplaceAjaxContent.bind(this)});
      this.init(a);
    }
    var e, b = !1;
    h.prototype = Object.assign({}, h.prototype, {init:function(a) {
      b = !1;
      a || (this.container = document.getElementById(this.containerId));
      if (this.isCollectionTemplate && (this.initMobileFilters(), this.initSort(), this.initFilters(), this.initPriceRange(), this.productGrid = new theme.ProductGrid(this.container), this.initInfiniteScroll(), this.sidebar = new theme.CollectionSidebar(), "true" == this.container.getAttribute("data-is-search"))) {
        window.on("load", this.initSearchInput.bind(this));
      }
      this.resizeContainer();
      this.windowWidth = window.innerWidth;
      window.on("resize" + this.namespace, this.resizeContainer.bind(this));
    }, initSort:function() {
      this.queryParams = new URLSearchParams(window.location.search);
      this.sortSelect = document.querySelector("#SortBy");
      this.sortBtns = document.querySelectorAll(".filter-sort");
      (this.sortSelect || this.sortBtn) && this.initParams();
      this.sortSelect && (this.defaultSort = this.sortSelect.getAttribute("data-default-sortby"), this.sortSelect.addEventListener("change", function() {
        this.onSortChange();
      }.bind(this)));
      this.sortBtns.length && this.sortBtns.forEach(a => {
        a.addEventListener("click", function() {
          document.dispatchEvent(new Event("filter:selected"));
          this.queryParams.sort_by = a.dataset.value;
          this.goToSortUrl();
        }.bind(this));
      });
    }, initParams:function() {
      this.queryParams = {};
      if (location.search.length) {
        for (var a = location.search.substr(1).split("&"), d = 0; d < a.length; d++) {
          var c = a[d].split("=");
          c.length && (this.queryParams[decodeURIComponent(c[0])] = decodeURIComponent(c[1]));
        }
      }
    }, resizeContainer:function() {
      if (window.innerWidth != this.windowWidth) {
        this.windowWidth = window.innerWidth;
        var a = 0, d = 0, c = document.querySelector("#SiteHeader"), f = document.querySelector("#SiteAnnouncement"), g = document.querySelector("#AnnouncementWrapper");
        e = 0;
        null != g && null != f && (a = f.offsetHeight, "true" == g.dataset.sticky && (e = a));
        null != c && (d = c.offsetHeight, "sticky" == c.dataset.sticky && (e += d));
        console.log(c);
        console.log("site_announcement_height: ", a);
        console.log("header_wrapper_height: ", d);
        console.log("header_wrapper_height: ", e);
        document.documentElement.style.setProperty("--sticky-padding-desktop", e + 25.0 + "px");
      }
    }, getSortValue:function() {
      return this.sortSelect.value || this.defaultSort;
    }, goToSortUrl:function() {
      this.queryParams.page && delete this.queryParams.page;
      window.location.search = decodeURIComponent(new URLSearchParams(Object.entries(this.queryParams)));
    }, onSortChange:function(a = null) {
      this.queryParams = new URLSearchParams(window.location.search);
      a ? this.queryParams.set("sort_by", a) : this.queryParams.set("sort_by", this.getSortValue());
      this.queryParams.delete("page");
      window.location.search = this.queryParams.toString();
    }, initInfiniteScroll:function() {
      var a = document.querySelector(".js-load-more");
      a && a.addEventListener("click", function(d) {
        var c = parseInt(document.querySelector("[data-all-pages]").value);
        d = parseInt(document.querySelector("[data-current-page]").value);
        document.querySelector("[data-collection-url]");
        a.classList.add("btn--loading");
        var f = document.querySelector("[data-next-url]").value, g = d + 1, k = f.replace("page=" + g, "page=" + (d + 2)), m = this.productGrid;
        fetch(f, {credentials:"same-origin", method:"GET"}).then(function(l) {
          return l.text();
        }).then(function(l) {
          document.querySelector("[data-next-url]").value = k;
          document.querySelector("[data-current-page]").value = g;
          l = (new DOMParser()).parseFromString(l, "text/html").querySelector(".grid-loader").innerHTML;
          document.querySelector(".grid-loader").insertAdjacentHTML("beforeend", l);
          m.init();
        }).then(() => {
          a.classList.remove("btn--loading");
          g < c && a.classList.remove("hide");
          g >= c && a.classList.add("hide");
        });
      }.bind(this));
    }, initFilters:function() {
      if (document.querySelectorAll(".tag-list input").length) {
        document.addEventListener("matchSmall", this.initMobileFilters.bind(this));
        this.bindBackButton();
        if (theme.config.stickyHeader) {
          this.setFilterStickyPosition();
          document.addEventListener("headerStickyChange", theme.Helpers.debounce(500, this.setFilterStickyPosition));
          var a = window.innerWidth;
          window.on("resize", theme.Helpers.debounce(500, function() {
            window.innerWidth != a && (a = window.innerWidth, this.setFilterStickyPosition());
          }.bind(this)));
        }
        document.querySelectorAll(".tag-list a").forEach(d => {
          d.addEventListener("click", this.onTagClick.bind(this));
        });
        document.querySelectorAll(".filter-form").forEach(d => {
          d.addEventListener("input", this.onFormSubmit.bind(this));
        });
      }
    }, initPriceRange:function() {
      document.querySelectorAll(".price-range").forEach(a => new theme.PriceRange(a, {onChange:this.renderFromFormData.bind(this)}));
    }, initMobileFilters:function() {
      if (!b) {
        var a = document.querySelector("#CollectionSidebarFilterWrap");
        if (a) {
          a = a.querySelector(".filter-wrapper").cloneNode(!0);
          var d = document.querySelector("#CollectionInlineFilterWrap");
          d.innerHTML = "";
          d.append(a);
          theme.collapsibles.init(d);
          b = !0;
        }
      }
    }, setActiveTag:function(a, d) {
      if (a) {
        var c = a.querySelector(".tag__text");
        a.classList.contains("tag--active") ? a.classList.remove("tag--active") : (a.classList.add("tag--active"), d.closest("li").classList.contains("tag--remove") ? a.remove() : document.querySelectorAll(".tag-list--active-tags").forEach(f => {
          const g = document.createElement("li"), k = document.createElement("a");
          g.classList.add("tag", "tag--remove");
          k.classList.add("btn", "btn--small");
          k.innerText = c.innerText;
          g.appendChild(k);
          f.appendChild(g);
        }));
      }
    }, onTagClick:function(a) {
      const d = a.currentTarget;
      if (!d.classList.contains("no-ajax")) {
        document.dispatchEvent(new Event("filter:selected"));
        a.preventDefault();
        a = d.parentNode;
        var c = new URL(d.href);
        this.setActiveTag(a, d);
        this.updateScroll(!0);
        this.startLoading();
        this.renderCollectionPage(c.searchParams);
      }
    }, onFormSubmit:function(a) {
      const d = a.target;
      if (!d.classList.contains("no-ajax")) {
        document.dispatchEvent(new Event("filter:selected"));
        a.preventDefault();
        a = d.closest("li");
        var c = d.closest("form");
        c = new FormData(c);
        this.setActiveTag(a, d);
        this.updateScroll(!0);
        this.startLoading();
        this.renderFromFormData(c);
      }
    }, onReplaceAjaxContent:function(a, d) {
      this.fetchOpenCollasibleFilters().forEach(c => {
        a.querySelectorAll(`[data-collapsible-id=${c}]`).forEach(this.openCollapsible);
      });
      document.getElementById(d.nodeId).innerHTML = a.getElementById(d.nodeId).innerHTML;
    }, renderFromFormData:function(a) {
      a = new URLSearchParams(a);
      this.renderCollectionPage(a);
    }, renderCollectionPage:function(a, d = !0) {
      this.ajaxRenderer.renderPage(window.location.pathname, a, d).then(() => {
        theme.sections.reinit("collection-template");
        this.updateScroll(!1);
        this.initPriceRange();
        theme.reinitProductGridItem();
        document.dispatchEvent(new CustomEvent("collection:reloaded"));
      });
    }, updateScroll:function(a) {
      document.getElementById("CollectionFilteredContent");
      theme.config.stickyHeader && document.querySelector("#SiteHeader");
    }, bindBackButton:function() {
      window.off("popstate" + this.namespace);
      window.on("popstate" + this.namespace, function(a) {
        a && (a = new URL(window.location.href), this.renderCollectionPage(a.searchParams, !1));
      }.bind(this));
    }, fetchOpenCollasibleFilters:function() {
      return [...Array.from(document.querySelectorAll("#CollectionSidebar .collapsible-trigger.is-open"))].map(a => a.dataset.collapsibleId);
    }, openCollapsible:function(a) {
      a.classList.contains("collapsible-content") && (a.style.height = "auto");
      a.classList.add("is-open");
    }, initSearchInput:function() {
      this.searchPageInput = document.getElementById("SearchInModal") || document.getElementById("SearchPageInput");
      this.searchPageInput.focus();
      if ("number" == typeof this.searchPageInput.selectionStart) {
        this.searchPageInput.selectionStart = this.searchPageInput.selectionEnd = this.searchPageInput.value.length;
      } else if ("undefined" != typeof this.searchPageInput.createTextRange) {
        var a = this.searchPageInput.createTextRange();
        a.collapse(!1);
        a.select();
      }
    }, setFilterStickyPosition:function() {
      var a = document.querySelector(".site-header").offsetHeight - 1;
      document.querySelector(".filters-toolbar").style.top = a + "px";
      var d = document.querySelector(".grid__item--sidebar");
      d && (d.style.top = a + 30 + "px");
    }, startLoading:function() {
      document.querySelector(".collection-grid__wrapper").classList.add("unload");
    }, forceReload:function() {
      this.init();
    }});
    return h;
  }();
  theme.ProductGrid = function() {
    function h(b) {
      this.container = b;
      this.type = this.container.querySelector(".product-grid").dataset.type;
      this.gapSize = this.scrollingDistance = 0;
      this.swatchWidth = 32;
      this.availableItems = 0;
      this.videoObjects = {};
      this.init();
    }
    var e = {viewChange:".grid-view-btn", productGrid:".grid-product", collectionGrid:".collection-grid__wrapper", colorSwatchImage:".product__swatch-image", colorSwatch:".color-swatch--small", quickViewBtn:".js-modal-open-quick-view", activeDrawer:"drawer--is-open", sliderPaddingLeft:"slider__padding-left", sliderPaddingRight:"slider__padding-right"};
    h.prototype = Object.assign({}, h.prototype, {init:function() {
      "quick-buy" == this.type && this.container.querySelectorAll(".quick-shop--form").forEach(c => {
        new theme.ProductQuickBuy(c);
      });
      if ("quick-view" == this.type) {
        var b = document.querySelector("#CartDrawer");
        b && (this.cartDrawerClass = b.dataset.scheme);
        this.container.querySelectorAll(".quick-product__btn").forEach(c => {
          this.viewDrawer = new theme.Drawers("ProductDrawer-" + c.dataset.productid, "view-" + c.dataset.productid);
          c.addEventListener("click", function(f) {
            var g = "ProductDrawer-" + c.dataset.productid;
            g = document.getElementById(g);
            f = this.cartDrawerClass.split(" ")[0];
            g.classList.add(f);
            g.classList.add("gradient");
            if (g && "false" == g.dataset.ismodal) {
              g.setAttribute("data-ismodal", !0);
              g = "ProductDrawer-" + c.dataset.productid;
              g = document.getElementById(g).querySelector(".drawer__scrollable").firstElementChild;
              var k = document.getElementById("AddToCartForm-" + c.dataset.sectionid + "-" + c.dataset.productid);
              k.classList.add(f);
              k.classList.add("gradient");
              g.appendChild(k);
              this.Product = new theme.Product(g);
            }
          }.bind(this));
        });
      }
      var a = this.container.querySelector(".product-grid"), d = this.container.querySelectorAll(e.viewChange);
      this.container.querySelectorAll(e.viewChange).forEach(c => {
        c.addEventListener("click", function() {
          d.forEach(g => {
            g.classList.remove("is-active");
          });
          c.classList.add("is-active");
          var f = c.dataset.view;
          a.dataset.view = f;
          theme.cart.updateAttribute("product_view", f);
          window.dispatchEvent(new Event("resize"));
        });
      });
      this.colorSwatch = this.container.querySelectorAll(e.colorSwatch);
      0 < this.colorSwatch.length && (this.colorSwatches = this.container.querySelectorAll(e.colorSwatch + ":not(.disabled)"), this.initColorSwatch(), window.on("resize", theme.Helpers.debounce(300, function() {
        this.initColorSwatchSlider();
      }.bind(this))), this.initColorSwatchSlider());
      this.container.getAttribute("data-section-player") && "true" == this.container.getAttribute("data-section-player") && this.container.querySelectorAll(".grid-product .product__media").forEach(c => {
        "youtube" == c.getAttribute("data-video-type") ? null == this.videoObjects[c.id] && (this.videoObjects[c.id] = new theme.YouTube(c.id, {videoId:c.dataset.youtubeId, videoParent:e.videoParent, autoplay:!1, style:c.dataset.videoStyle, loop:!1, muted:!0, controls:!1, events:{onReady:this.youtubePlayerReady.bind(this)}})) : "false" == c.dataset.listener && (c.dataset.listener = "true", c = c.closest(".grid__item"), c.querySelector(".quick-play__btn").addEventListener("click", function(f) {
          f = f.target.closest(".product__image-link").querySelector(".product__media");
          f == this.player && !1 === f.paused ? (this.player.pause(), this.player.currentTime = 0, this.player.closest(".product__image-link").querySelector(".quick-play__btn").classList.remove("playing"), this.player = null) : (this.player = f, this.player.play(), this.player.closest(".product__image-link").querySelector(".quick-play__btn").classList.add("playing"));
        }.bind(this)), c.addEventListener("mouseleave", function(f) {
          this.player && (this.player.pause(), this.player.currentTime = 0, this.player.closest(".product__image-link").querySelector(".quick-play__btn").classList.remove("playing"), this.player = null);
        }.bind(this)));
      });
    }, youtubePlayerReady:function(b) {
      var a = b.target.getIframe().id;
      this.videoObjects[a] && (b = b.target.getIframe().closest(".grid__item"), b.querySelector(".quick-play__btn").addEventListener("click", function(d) {
        var c = d.target.closest(".quick-play__btn");
        if (c) {
          var f = this.videoObjects[c.dataset.productid].videoPlayer;
          f == this.player && !1 === f.paused || f == this.player && c.classList.contains("playing") ? (this.player.stopVideo(), this.player.currentTime = 0, this.player = null, d.target.closest(".product__image-link").querySelector(".quick-play__btn").classList.remove("playing")) : (this.player = f, this.player.playVideo(), d.target.closest(".product__image-link").querySelector(".quick-play__btn").classList.add("playing"));
        }
      }.bind(this)), b.addEventListener("mouseleave", function(d) {
        this.player && (this.player.stopVideo(), this.player = null, d.target.querySelector(".quick-play__btn").classList.remove("playing"));
      }.bind(this)));
    }, initColorSwatchSlider:function() {
      this.resize();
      this.container.querySelectorAll(".product__colors > .main-swacthes-container").forEach(b => {
        var a = b.querySelectorAll(".color-swatch--small").length;
        const d = b.parentElement.querySelector(".btn--prev"), c = b.parentElement.querySelector(".btn--next");
        a <= this.availableItems + 2 ? c.classList.add("hide") : (d.addEventListener("click", function() {
          this.scrollToPrevious(b, d, c);
        }.bind(this)), c.addEventListener("click", function() {
          this.scrollToNext(b, d, c);
        }.bind(this)), d.classList.add("hide"), c.classList.remove("hide"), b.style.setProperty("width", "calc(100% - " + this.swatchWidth + "px)"), b.firstElementChild.classList.remove(e.sliderPaddingLeft), b.firstElementChild.classList.add(e.sliderPaddingRight), b.scrollLeft = 0);
      });
    }, resize:function() {
      var b = this.container.querySelector(".product__colors");
      this.container.querySelector(".scroll-content") ? this.swatchWidth = this.container.querySelector(".scroll-content").offsetHeight : this.swatchWidth = 0;
      this.availableItems = Math.trunc((b.offsetWidth - 2 * this.swatchWidth) / this.swatchWidth);
      var a = this.availableItems + 2;
      this.gapSize = (b.offsetWidth - this.swatchWidth * a) / (a - 1);
      this.scrollingDistance = this.availableItems * this.swatchWidth + this.availableItems * this.gapSize;
      document.documentElement.style.setProperty("--ColorSwatchSlider", this.gapSize + "px");
    }, scrollToPrevious:function(b, a, d) {
      var c = this.scrollingDistance;
      b.firstElementChild.classList.add(e.sliderPaddingLeft);
      b.firstElementChild.classList.add(e.sliderPaddingRight);
      b.scrollLeft <= this.scrollingDistance + this.swatchWidth + 2 * this.gapSize && (c = this.scrollingDistance + this.swatchWidth + 2 * this.gapSize, a.classList.add("hide"), b.style.setProperty("width", "calc(100% - " + this.swatchWidth + "px)"), b.firstElementChild.classList.remove(e.sliderPaddingLeft));
      d.classList.remove("hide");
      b.scrollBy({left:-c, behavior:"smooth"});
    }, scrollToNext:function(b, a, d) {
      var c = this.scrollingDistance;
      b.firstElementChild.classList.add(e.sliderPaddingLeft);
      0 == b.scrollLeft ? (c = this.scrollingDistance + this.swatchWidth + this.gapSize, a.classList.remove("hide"), b.style.setProperty("width", "calc(100% - " + 2 * this.swatchWidth + "px)")) : b.scrollLeft + 2 * b.offsetWidth >= b.scrollWidth && d.classList.add("hide");
      b.scrollBy({left:c, behavior:"smooth"});
    }, initColorSwatch:function() {
      this.colorSwatches.forEach(b => {
        if (!b.classList.contains("color-swatch--filter")) {
          var a = "true" == b.getAttribute("data-quick-buy") ? "click" : "mouseenter";
          b.addEventListener(a, function() {
            this.setColorSwatchImage(b);
          }.bind(this));
        }
      });
    }, setColorSwatchImage:function(b) {
      var a = b.closest(".grid__item");
      a.querySelectorAll(".product__swatch-image").forEach(c => {
        c.classList.remove("is-active");
      });
      a.querySelectorAll(".color-swatch").forEach(c => {
        c.classList.remove("is-active");
      });
      a = this.container.querySelector(".product__swatch-image--" + b.dataset.variantId);
      b.classList.add("is-active");
      if (a) {
        a.style.backgroundImage = "url(" + b.dataset.variantImage + ")";
        a.classList.add("is-active");
        a = b.dataset.url;
        var d = b.closest(".product__content");
        b = d.querySelector(".product__image-link");
        d = d.querySelector(".product__meta-link");
        b.setAttribute("href", a);
        d.setAttribute("href", a);
      }
    }});
    return h;
  }();
  theme.ProductQuickBuy = function() {
    function h(e) {
      this.container = e;
      this.init();
    }
    h.prototype = Object.assign({}, h.prototype, {init:function() {
      var e = this.container.querySelector("[data-add-to-cart]");
      e ? new theme.AjaxProduct(this.container, ".cart__checkout") : new theme.AjaxProduct(this.container, ".quick-product__btn-submit");
      var b = this.container.querySelector(".quick-product__btn-select");
      null != b && b.addEventListener("change", function(l) {
        this.container.querySelector(".btn").click();
        l.target.selectedIndex = 0;
      }.bind(this));
      var a = this.container.querySelector(".variant-wrapper--dropdown");
      if (null != a) {
        var d = this.container.querySelector(".quick-product__btn"), c = this.container.querySelector("[data-quick-cancel]"), f = a.querySelector("[data-bundle-variant-json]");
        f = JSON.parse(f.innerHTML);
        var g = a.querySelector("[data-bundle-current-variant-json]");
        this.currentVariantObject = JSON.parse(g.innerHTML);
        theme.SetAvailability.init(null, this.currentVariantObject, f, a, "dropdown", this.currentVariantObject);
        a.querySelector("[data-bundle-variant-input]");
        f = a.querySelector("[data-bundle-variant-json]");
        f = JSON.parse(f.innerHTML);
        var k = {container:a, enableHistoryState:!1, singleOptionSelector:".bundle-variant-input-wrap", originalSelectorId:a.querySelector("[data-bundle-variant-input]"), variants:f, autoSelection:a.dataset.autoselect}, m = new slate.Variants(k);
        d && d.addEventListener("click", function(l) {
          a.classList.contains("hide") && (a.classList.remove("hide"), d.classList.add("hide"));
        }.bind(this));
        c && c.addEventListener("click", function(l) {
          a.classList.add("hide");
          d.classList.remove("hide");
        }.bind(this));
        e && e.addEventListener("click", function(l) {
          this.container.querySelector("[data-bundle-variant]").value = k.container.dataset.id;
          this.container.querySelector(".btn").click();
        }.bind(this));
        a.addEventListener("change", function(l) {
          theme.SetAvailability.init(null, m.currentVariant, k.variants, k.container, "dropdown", this.currentVariantObject);
          this._updatePrice(this.container.querySelector(".cart__price"), m.currentVariant);
          this._updateImages(this.container.querySelector(".cart__image img"), m.currentVariant);
          this.container.querySelector("[data-bundle-variant]").value = k.container.dataset.id;
          b = this.container.querySelector("#BundleProductVariant-" + a.dataset.index);
        }.bind(this));
      }
    }, _updatePrice:function(e, b) {
      e && (e.innerHTML = theme.Currency.formatMoney(b.price, theme.settings.moneyFormat));
    }, _updateImages:function(e, b) {
      e && b.featured_image.src && (e.parentElement.style.paddingBottom = 100 / b.featured_media.preview_image.aspect_ratio + "%", e.src = b.featured_media.preview_image.src, e.srcset = b.featured_media.preview_image.src.toString());
    }});
    return h;
  }();
  (function(h) {
    "loading" != document.readyState ? h() : document.addEventListener("DOMContentLoaded", h);
  })(function() {
    theme.sections.register("collection-template", theme.Collection);
    theme.sections.register("collection-sidebar", theme.CollectionSidebar);
    theme.sections.register("product-grid", theme.ProductGrid);
    theme.sections.register("product-quick-shop", theme.ProductQuickBuy);
    theme.sections.register("product-quick-view", theme.ProductQuickView);
  });
})();